var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    class: _vm.type,
    attrs: {
      "data-wio-id": _vm.id
    }
  }, [_c('section', _vm._b({}, 'section', _vm.options(_vm.template.data), false), [_c(_vm.currentComponent(_vm.type), {
    tag: "component",
    attrs: {
      "tags": _vm.tags,
      "blog-category": _vm.blogCategory,
      "payload": _vm.template.data
    }
  }), _vm._v(" "), _vm._l(_vm.slices, function (slice) {
    return [_c(_vm.currentComponent(slice.type), {
      key: slice.position,
      tag: "component",
      attrs: {
        "payload": slice.payload.editorial,
        "tracking": _vm.template.tracking,
        "catalog": slice.payload.catalog,
        "articles": _vm.results
      }
    })];
  })], 2), _vm._v(" "), _c('Seo', {
    attrs: {
      "seo": _vm.template.data,
      "type": _vm.type
    }
  }), _vm._v(" "), _c('OpenGraph', {
    attrs: {
      "edito": _vm.template.data,
      "slices": _vm.slices,
      "type": _vm.type
    }
  }), _vm._v(" "), _c('TcVars', {
    attrs: {
      "vars": _vm.tcVars
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };